<template>
    <pw-modal
        v-model="visibility"
        size="xs"
        title="Atualize o App!"
        subTitle="Uma nova versão do App do Educador está disponível. Recarregue o App para aplicar as melhorias e ter uma experiência ainda melhor."
        persistent
    >
        <div class="modalConfirmation">
            <div class="modalConfirmation__buttons" style="flex-direction: column;">
                <pw-button
                    :label="loading ? 'Atualizando' : 'Recarregar'"
                    icon="reload"
                    :size="24"
                    iconPosition="left"
                    @click="onAccept"
                    :loading="loading"
                    :disabled="loading"
                    full-width
                />
            </div>
        </div>
    </pw-modal>
</template>
<script setup>
import {computed, ref} from 'vue'
import PwButton from '@/pwComponents/PwButton/PwButton.vue';
import PwModal from '@/pwComponents/PwModal/PwModal.vue';

const emit = defineEmits(['update:opened', 'accept', 'decline']);

const props = defineProps({
    opened: {
        type: Boolean,
        default: false
    },
})

const loading = ref(false)

const visibility = computed({
    get() {
        return props.opened
    },
    set(value) {
        emit('update:opened', value)
    }
})

const onAccept = () => {
    emit('accept')
    loading.value = true
}
</script>
<style lang="scss" scoped>
@import './ModalConfirmationStyle.scss';
</style>